export default __webpack_public_path__ + "static/media/craon15.32619135.jpg";